import JobEdit from '@/components/company/jobs/edit/JobEdit.vue'

const defaultFilterValues = {
  code: '',
  name: '',
  isDeleted: false
};

export default {
  name: 'JobList',
  components: {
    JobEdit
  },
  data () {
    return {
      loading: true,
      currentReq: null,
      tableItems: [],
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues),
      tableSorting: { item: 'code', direction: 'asc' },
      paging: { limit: 20, page: 1, total: 0, pages: 0 },
      isMounted: false
    };
  },
  computed: {
    tableHeaders () {
      const headers = [
        { key: 'name.' + this.$i18n.locale, label: this.$t('company-structure.job.name'), sortable: false, filterKey: 'name' },
        { key: 'code', label: this.$t('general.item.code'), sortable: true, filterKey: 'code' },
        { key: 'workspace_type_id', label: this.$t('company-structure.job.workspace_type'), format: 'formatFromConfig', configKey: 'job_workspace_types', configParam: 'name' }
      ];
      if (this.filterValues.isDeleted) {
        headers.push({ key: 'deleted_at', label: this.$t('general.item.deleted'), format: 'formatYesNo' });
      }
      if (this.canEdit) {
        const actions = [];
        if (this.canEdit) {
          actions.push({ label: this.$t('menu.companies.job.edit'), emit: 'editItem', bicon: 'pencil-fill', class: 'btn-warning' });
          actions.push({ label: this.$t('menu.companies.job.delete'), emit: 'deleteItem', class: 'btn-danger', bicon: 'trash', ifconfig: { param: 'deleted_at', value: null } });
          actions.push({ label: this.$t('menu.companies.job.restore'), emit: 'restoreItem', class: 'btn-success', bicon: 'clock-history', ifconfig: { param: 'deleted_at', value: null, notCheck: true } });
        }
        headers.push({ key: 'actions', label: '', actions: actions });
      }
      return headers;
    },
    tableExpandConfig () {
      return null;
    },
    tableFilterConfig () {
      const filters = { };
      filters.code = { type: 'text', label: '', colOnlyFilter: true };
      filters.name = { type: 'text', label: '', colOnlyFilter: true };
      filters.isDeleted = { type: 'checkbox-single', label: this.$t('general.filters.deleted'), inlineLabel: true };
      return filters;
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-company-settings');
    },
    requestPath () {
      let path = this.ApiRequest.addGetParamsToPath('config/company/jobs/list?perPage=' + this.paging.limit + '&page=' + this.paging.page, this.filterValues, true);
      if (this.tableSorting.item) {
        path += '&order=' + this.tableSorting.item + ',' + this.tableSorting.direction;
      }
      return path;
    },
    tableActions () {
      const actions = { download: false, clearCache: true };
      if (this.canEdit) {
        actions.add = { title: this.$t('menu.companies.job.new') };
        if (this.ApiRequest.userHasPermission('edit-all-users')) {
          actions.extra = [
            { title: this.$t('menu.companies.job.updateAD'), icon: 'briefcase-fill', event: 'updateADJobs', class: 'btn-secondary' }
          ]
        }
      }
      return actions;
    }
  },
  methods: {
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      this.loading = true;
      const self = this;
      this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, {}, function (response) {
        if (response.data) {
          self.tableItems = response.data;
          self.paging = response.paging;
          self.loading = false;
        }
      });
    },
    clearFilters () {
      this.filterValues = this.BasicHelper.cloneObject(defaultFilterValues);
      this.getTableData();
    },
    itemUpdated () {
      this.$emit('saved');
      this.getTableData();
    },
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    },
    updateFilter (key, value) {
      if (this.filterValues[key] !== value) {
        this.filterValues[key] = this.BasicHelper.cloneObject(value);
        this.paging.page = 1;
        this.getTableData();
      }
    },
    deleteItem (el, approved) {
      if (approved) {
        this.setDeleted(el, 1);
      } else {
        this.$refs.itemDeleteMsgBox.show(el, this.$t('company-structure.job.deleteTitle'), this.$t('company-structure.job.deleteMessage', { name: this.BasicHelper.getTranslation(el.name) }))
      }
    },
    restoreItem (el) {
      this.setDeleted(el, 0);
    },
    setDeleted (el, isDeleted) {
      this.loading = true;
      const self = this;
      this.ApiRequest.request('config/company/jobs/deleted', this.ApiRequest.REQUEST_POST, { id: el.id, code: el.code, deleted: isDeleted }, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
          self.loading = false;
        } else {
          self.getTableData();
        }
      });
    },
    updateADJobs (el = null, approved = 0) {
      if (approved) {
        const self = this;
        this.ApiRequest.request('config/company/jobs/update-ldap', this.ApiRequest.REQUEST_FILEUPLOAD, [], function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          }
        });
      } else {
        this.$refs.updateLdapMsgBox.show(el, this.$t('company-structure.job.updateLdapTitle'), this.$t('company-structure.job.updateLdapMessage'))
      }
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    this.getTableData();
    this.isMounted = true;
  }
}
